import { useEffect, useRef } from 'react';
import toDollars from 'utils/to-dollars';

export default function useSurfsideViewProduct({ productUrl, variant }) {
  const storedProductUrl = useRef(null);
  useEffect(() => {
    if (
      window &&
      typeof window.surf === 'function' &&
      variant &&
      productUrl &&
      productUrl !== storedProductUrl.current
    ) {
      const {
        brand,
        category,
        discountedPricePerQuantity: {
          discountedPrice: { centAmount: discountedCents } = {},
        } = {},
        price: { centAmount: fullPriceCents, currencyCode } = {},
        name,
        SKU,
        variation,
      } = variant;

      const displayCents = discountedCents || fullPriceCents;
      const formattedPrice = toDollars(displayCents).toFixed(2);

      window.surf('addProduct:lume', {
        id: SKU,
        brand,
        category,
        currency: currencyCode,
        name,
        price: formattedPrice,
        quantity: 1,
        variant: variation,
      });

      window.surf('setCommerceAction:lume', 'detail');
      storedProductUrl.current = productUrl;
    }
  }, [productUrl, variant]);
}
